import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';

const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex align-items-center justify-content-center surface-ground px-3">
      <div className="w-full" style={{ maxWidth: '480px' }}>
        <Card className="text-center">
          <div className="mb-4">
            <i className="pi pi-exclamation-triangle text-6xl text-orange-500"></i>
          </div>
          
          <h1 className="text-4xl font-bold text-primary mb-3">404</h1>
          <h2 className="text-xl font-semibold mb-3">Page Not Found</h2>
          
          <p className="text-color-secondary mb-4">
            The page you are looking for might have been removed, 
            had its name changed, or is temporarily unavailable.
          </p>
          
          <div className="flex flex-column gap-2">
            <Button
              label="Go to Dashboard"
              icon="pi pi-home"
              onClick={() => navigate('/dashboard')}
            />
            <Button
              label="Go Back"
              icon="pi pi-arrow-left"
              className="p-button-text"
              onClick={() => navigate(-1)}
            />
          </div>
        </Card>
        
        <div className="text-center mt-4">
          <p className="text-sm text-color-secondary">
            © 2024 Legal and Human Rights Centre. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;